import Service from "../Service";
const resource = "/TasTransportPaymentRecord/";

export default {
  pagination(parameters, requestID) {
    return Service.post(resource + "pagination", parameters, {
      params: { requestID },
    });
  },
  save(parameters, requestID) {
    return Service.post(resource + "save", parameters, {
      params: { requestID },
    });
  },
  saveMassive(parameters, requestID) {
    return Service.post(resource + "saveMassive", parameters, {
      params: { requestID },
    });
  },
  savePDFGuia(PymReferralGuide, requestID) {
    return Service.post(resource + "savePDFGuia", {}, {
      params: { requestID, PymReferralGuide },
    });
  },
  createZipPDFAnexos(parameters, requestID) {
    return Service.post(resource + "createZipPDFAnexos", parameters, {
      params: { requestID },
      responseType: 'arraybuffer',
    });
  },
};
